export const hasRole = (user: any, role: string) => user.roles.includes(role)